module.exports = __webpack_public_path__ + "static/media/slika1.a53006f0.png";